<template>
  <div>
    <!-- 头部start -->
    <crumbs :activeIndex="1"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement">
      <img src="../../static/img/galllery.png" alt />
    </div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div class="router-active">
          <img src="../../static/img/icon.png" alt=""><router-link to="/">首页 ></router-link>展馆概况><span style="color:#0078ff">{{hall}}</span>
        </div>
      </div>
    </div>
    <!-- 导航end -->

    <div class="popular-list min">
      <div class="popular-left">
        <!-- {{Name}} -->
        <div class="popular-box" v-for="(active,index) in gearedList" :key="index">
          <div class="popular-tal">{{active.Title}}</div>
          <div v-html="active.Description"></div>
        </div>
      </div>
      <div class="popular-right">
        <h3>展馆概况</h3>
        <div
          class="popular-r-text"
          :class="{active:index==activeIndex}"
          @click="press(index,item)"
          v-for="(item,index) in hallList"
          :key="index"
        >
          <span>{{item.Name}}</span>
           <img v-if="index==activeIndex" :class="{active:index==activeIndex}" src="../../static/img/arrow.png" alt />
          <img  v-else src="../../static/img/gray.png" alt />
        </div>
        <div class="popular-r-img">
          <img src="../../static/img/active2.png" alt />
        </div>
      </div>
    </div>
    <tab></tab>

    <!-- 友情链接end -->
    <Footer></Footer>
  </div>
</template>

<script>
import tab from "@/components/tab.vue";
export default {
  components: {
    tab
  },
  data() {
    return {
      hall:"展馆概况",
      activeList: [],
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      Name: "",
      show: false,
      shows: true,
      activ: true,
      activcor: true,
      // activated: "",
      activeIndex: 0,
      hallList:[],
      gearedList:[]
    };
  },
  created() {
    let id = "ccbeaa9a-0b17-4be9-b7fc-be4dfeb19978";
    this.activeFun(id);
    this.hallListFun()
  },
  methods: {
      hallListFun() {
      this.$http
        .get("/yxht//Categories/GetList", {
          ParentId: "a27a9e00-dcf9-4b39-b02b-0aa23e0aa28c",
          Type: 2,
          rows: 4,
          page: 1
        })
        .then(res => {
          // this.hallList =
          this.hallList = res.data.rows; //热门展项
        });
    },
    // 科普活动
    activeFun(id) {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: id,
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.gearedList = this.geared.rows;
          this.gearedList.forEach(item=>{
             item.Description = item.Description.replace(
              /\<img src="/gi,
             '<img style="margin:0 auto" src="http://www.sxszstm.com'
            );
          })
        });
    },

    press(index,item) {
      this.hall = item.Name
      this.activeIndex = index;
     let id = item.Id
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: id,
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.gearedList = this.geared.rows;
            console.log(this.gearedList)
          this.gearedList.forEach(item=>{
             item.Description = item.Description.replace(
              /\<img src="/gi,
             '<img style="margin:0 auto" src="http://www.sxszstm.com'
            );
          })

        });

    }
  }
};
</script>

<style scoped>
/* table样式
 */
 .router-active{
   display: flex;
   align-items: center;
   height: 60px;
 }
 .router-active img{
   width: 17px;
   height: 20px;
   margin-right: 6px;

 }
 .router-link-active{
   color: #000000;
 }
 .popular-b-time-day{
   display: flex;
   align-items: center;
 }
  .popular-b-time-day span{
   margin-left: 7px;
 }
 .popular-b-time-day img{
   width:18px;
   height: 18px;
 }
.popular-r-img img {
  width: 270px;
  height: 210px;
}
.activated {
  /* width: 100%;
  height: 89px; */
  background: #0078ff;
}
.activcor {
  color: orange;
}
.y-advertisement {
  width: 100%;
  height: 340px;
}
.y-advertisement img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.popular-list {
  display: flex;
  margin: 0px auto;
  margin-top: 50px;
  padding-bottom:60px;
}
.popular-box {
  width: 876px;
  /* height: 186px;*/
  /* padding-left: 30px; */
  /* margin-top: 60px; */
  /* display: flex; */
  /* align-items: center; */
}
.popular-box /deep/ img{
  margin: 0 auto;
}
.popular-tal{
      width: 100%;
    margin-bottom: 41px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
}
.popular-box:active {
  background: rgba(0, 120, 255, 0.1);
}
.box {
  width: 90%;
  display: flex;
  justify-content: space-between;
}
/* .popular-box:nth-child(2n) {
  background: rgba(0, 120, 255, 0.1);
} */
.popular-box .popular-b-img {
  width: 203px;
  height: 126px;
  /* background-color: red; */
}
.popular-b-img img {
  width: 203px;
  height: 126px;

}
.popular-b-text {
  width: 65%;
  margin-left: 26px;
}
.popular-box h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
}
.popular-b-text p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 设置行数 */
  -webkit-box-orient: vertical;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 34px;
}
.popular-b-time {
  display: flex;
  justify-content: space-between;
}
.popular-b-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-top: 29px;
}
.popular-b-time-looks{
  display: flex;
  align-items: center;
  color: #666666;
}
.popular-b-time-look img {
  /* display: inline-block; */
  width: 14px;
  height: 14px;
  /* vertical-align: middle; */
  margin-left:6px ;
}
.popular-right {
  width: 270px;
height: 475px;
background: #FFFFFF;
box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
border-radius: 10px;
  margin-left: 40px;
}
.popular-right h3 {
  height: 85px;
  line-height: 85px;

  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.popular-right .popular-r-text {
  padding: 0 20px;
  font-size: 18px;
  height: 60px;
  line-height: 60px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popular-r-text.active {
  color: #fff;
  background-color: #0078ff;
}
.popular-r-text img{
  width:18px;
  height: 18px;
}
.popular-right .popular-r-text img {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
/* background: #0078FF; */
</style>



// WEBPACK FOOTER //
// src/view/exhibition.vue